import { createSocialMergeExistedModel } from '@cian/api-models/monolith-csharp/api/users/v1/social-merge-existed';
export function socialMerge(httpApi, subdomain, parameters) {
  return httpApi.fetch(createSocialMergeExistedModel({
    parameters: parameters
  }), {
    subdomain: subdomain,
    bodyAsEncodeString: true,
    requestConfig: {
      headers: [['Content-Type', 'application/x-www-form-urlencoded']]
    }
  });
}